import angular from 'angular';
import {
  ssDialogService,
  loaderService,
  emDataService,
  vmSharedModelService,
  emSharedModelService
} from 'app/services';
import {
  alerts,
  actionIcon
} from 'app/components/global';
import validator, { name as validatorName } from './messages/function-vendor-unique-name.validator.directive';
import controller from './add-function-vendor-dialog.controller';
import template from './add-function-vendor-dialog.html';
import messageTpl from './messages/function-vendor-name.messages.html';
import product from '../products';
import addVendorProductDialog from '../products/dialog.addVendorProductDialog';


class dialogService {
  getOptions($event, {
    vendor, addCallback
  }) {
    return {
      controller,
      controllerAs: 'addFunctionVendorDialogVM',
      locals: {
        vendor,
        addCallback
      },
      bindToController: true,
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.advisory.enterpriseModeling.addFunctionVendorDialog', [
  alerts,
  actionIcon,
  ssDialogService,
  loaderService,
  emDataService,
  vmSharedModelService,
  product,
  addVendorProductDialog,
  emSharedModelService
])
  .service('addFunctionVendorDialog', dialogService)
  .directive(validatorName, validator)
  .run(($templateCache) => {
    $templateCache.put('function-vendor-name.messages.html', messageTpl);
  })
  .name;

console.log('app.components.advisory.enterpriseModeling.addFunctionVendorDialog created');
